export default "__VITE_ASSET__D$M44TW$__"